/**
 * Предвыбранные интересы для регистрации и редактирования профиля (YouGile 4cd850a2).
 * Выбор только из списков (это + allInterests), ручной ввод «своего варианта» отключён.
 *
 * Тип CatalogInterest обязывает каждое значение входить в финальный справочник
 * (INTEREST_GROUPS): предлагать то, чего нет в каталоге «Показать все», нельзя.
 * Значение вне справочника не пройдёт tsc — проверка ловится в CI, а не глазами.
 */
import type {CatalogInterest} from "./interestGroups";

/** Максимум интересов в профиле. */
export const MAX_INTERESTS = 7;

export const INTEREST_OPTIONS: CatalogInterest[] = [
  "Путешествия",
  "Музыка",
  "Кино",
  "Спортзал",
  "Кулинария",
  "Литература",
  "Фотография",
  "Танцы",
  "Питомцы",
  "Хайкинг",
];
